
class BusinessReasonTypeCell extends UITableViewCell
{
    private titleTextField:MUITextField = null;
    private scopeComboBox:MUIComboBox = null;

    private _item:BusinessReasonType = null;

    awakeFromHTML(){
        this.titleTextField = MUIOutlet(this, "title-tf", "MUITextField");
        if (this.titleTextField) this.titleTextField.setOnChangeText(this, function(this:BusinessReasonTypeCell, control:MUITextField, value:string){
            if (this._item != null) this._item.title = value;
        });

        this.scopeComboBox = MUIOutlet(this, "scope-cb", "MUIComboBox");
        if (this.scopeComboBox) this.scopeComboBox.setOnChangeAction(this, function(this:BusinessReasonTypeCell, control:MUIComboBox, value:string){
            if (this._item != null) this._item.scope = parseInt(value);
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(item:BusinessReasonType){
        this._item = item;
        this.titleTextField.text = item.title;
        this.scopeComboBox.selectItem(item.scope ?? BusinessReasonTypeScope.both);
    }
}
